import { useTranslation } from 'react-i18next'
import {
  getProductArrivalTexts,
  type ProductArrivals,
} from '../productArrivals.utils'

export function ProductArrivalLines(productArrivals: ProductArrivals) {
  const { t } = useTranslation()
  const { tilesArrivalText, photoBookArrivalText } = getProductArrivalTexts(
    t,
    productArrivals
  )

  return (
    <>
      <div data-testid="tiles-arrival-line">{tilesArrivalText}</div>
      <div data-testid="photo-book-arrival-line">{photoBookArrivalText}</div>
    </>
  )
}
